import { Component, ComponentRef, inject, OnDestroy, OnInit, viewChild, ViewContainerRef } from '@angular/core'
import { map, Observable, Subscription } from 'rxjs'
import { CustomContent } from '../../shared/services/custom-content/custom-content'
import { AsyncPipe } from '@angular/common'
import { SeoService } from '../../shared/services/seo/seo-service'
import { PageContent } from '../../shared/intefaces/interfaces'
import { ActivatedRoute } from '@angular/router'
import { SharedContent } from '../../shared/services/shared-content/shared-content'

@Component({
	selector: 'app-sell-my-car',
	imports: [AsyncPipe],
	templateUrl: './sell-my-car.html',
	styleUrl: './sell-my-car.css',
})
export class SellMyCar implements OnInit, OnDestroy {
	viewContainer = inject(ViewContainerRef)
	container = viewChild.required('container', {
		read: ViewContainerRef,
	})
	$pageContent!: Observable<PageContent | undefined>
	urlSubscription!: Subscription

	private customContentService = inject(CustomContent)
	private sharedContentService = inject(SharedContent)
	private seoService = inject(SeoService)
	private route = inject(ActivatedRoute)

	ngOnInit(): void {
		this.urlSubscription = this.route.url.subscribe((segments) => {
			const currentPath = segments.map((segment) => segment.path).join('/')
			this.$pageContent = this.customContentService.getPageContent(currentPath).pipe(
				map((resp) => {
					if (!resp) return // display 404 or home page?
					this.sharedContentService.setPhoneNumber(resp.phoneNumber)
					this.seoService.setCanonicalURL()
					this.seoService.setPageMetaData(resp.title, resp.description)

					this.viewContainer.clear()
					Object.entries(resp.content).forEach((key) => {
						this.loadComponent(key[1])
					})

					return resp
				}),
			)
		})
	}

	loadComponent(key: any) {
		const componentType = this.customContentService.mapToComponentType(key.sharedComponentName)

		if (!componentType) return
		const componentRef: ComponentRef<any> = this.viewContainer.createComponent(componentType)

		// Set inputs for the dynamically created component
		componentRef.instance.content = key
	}

	ngOnDestroy(): void {
		this.viewContainer?.clear()
		this.urlSubscription?.unsubscribe()
	}
}
